module.exports = __webpack_public_path__ + "static/fonts-5b4b95d99b3ce1f92f844e1cdd7774d7.png";